import { USER_REQUEST,  USER_ERROR, USER_SUCCESS, USER_UPDATE_DATA, USER_SET_DEFAULT_SHIP_DATA, USER_CHECK_AGE, ACCEPT_COOKIES } from '../actions/user'
import Vue from 'vue'
import { AUTH_LOGOUT, AUTH_OK } from '../actions/auth'
import { DECRYPT, ENCRYPT } from '../actions/auth'
import axios from 'axios'
import authData from '../modules/auth'
const state = { status: '', profile: {}, defaultShipData: {}, checkAge: localStorage.getItem('checkAge') || false, acceptCookies: localStorage.getItem('acceptCookies') || false }

const getters = {
  getProfile: state => state.profile,
  getDefaultShipData: state => state.defaultShipData,
  isComplateAccount: state => !!state.profile.name,
  isProfileLoaded: state => !!state.profile.name,
  checkAge: state => !!state.checkAge,
  acceptCookies: state => !!state.acceptCookies
}
const moment = require('moment')
const actions = {
  [USER_REQUEST]: ({ commit, dispatch }) => {
    commit(USER_REQUEST)
    if (localStorage.getItem('22a5s2dffe$fswe565') && localStorage.getItem(process.env.TOKENKEY) ) {
      //@*&^%%$###%@@#^^ -> token
      //@*&^%($##^%@@#^^ -> jwtToken

      var data = { 

        '@*&^%%$###%@@#^^': localStorage.getItem('22a5s2dffe$fswe565'), //TOKEN
        '@*&^&%$####@@#^^': '$vr4' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + localStorage.getItem('22a5s2dffe$fswe565').substring(1, 8) + '3453455',
        '@*&^%%$####%@@#^^': '$2y$10$weQPwu16AY/qh1UXJJxkQubT.s0dcVF9rHnwpwDH8URb2ZlaUruJ2',
        '@*&^%%$###%@$!^^': '$34d'+localStorage.getItem('22a5s2dffe$fswe565') + '3',
        '@*&^%($##^%@@#^^': localStorage.getItem(process.env.TOKENKEY), //JWTTOKEN
        '@*&^#%$###%@##^^': '$4fe' + localStorage.getItem(process.env.TOKENKEY) + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + localStorage.getItem('22a5s2dffe$fswe565').substring(1, 20) + 'sdtrrdf',
        '@*&^%###$###%@@#^^': '$34f' + localStorage.getItem(process.env.TOKENKEY).substring(9, 20) + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + 'wer345f',
        '@*&^%%$###%@$!^^': '$34d'+localStorage.getItem('22a5s2dffe$fswe565') + '3',
        '@*&^%%$###%@$!^#^': '$33d'+localStorage.getItem(process.env.TOKENKEY) + '2',
        '@*&^%%$###%@$!^^&^': '$32d'+localStorage.getItem('22a5s2dffe$fswe565') + '3',
        '@*&^%%$###%@$!^)(^': '$31d'+localStorage.getItem(process.env.TOKENKEY) + '3',
        '@*&^%%$###%@$!^)^': '$38d'+localStorage.getItem('22a5s2dffe$fswe565') + '3',

      }
      commit(ENCRYPT, data)
      data = authData.state.tempEncrypt
      axios({ url: process.env.ROOT_API + 'api/getUser',  data: { data }, method: 'POST', headers: { 'Authorization': 'Bearer ' + process.env.AUTH_TOKEN, 'Content-type': 'application/json' } })
        .then(resp => {
          commit(DECRYPT, resp.data)
        resp.data = authData.state.tempCrypt
          commit(USER_SUCCESS, resp.data)
          dispatch(AUTH_OK)
        })
        .catch(resp => {
          commit(DECRYPT, resp.response.data)
          resp.response.data = authData.state.tempCrypt
          dispatch(AUTH_LOGOUT, resp.response.data.message)

          commit(USER_ERROR, resp.response.data.message)
          // if resp is unauthorized, logout, to

        })

    }

  },
  [USER_UPDATE_DATA]: ({ commit, dispatch }) => {
    commit(USER_UPDATE_DATA)

  },
  [USER_SET_DEFAULT_SHIP_DATA]: ({ commit, dispatch }, shipData) => {
    commit(USER_SET_DEFAULT_SHIP_DATA, shipData)
  },
  [USER_CHECK_AGE]: ({ commit, dispatch }) => {
    localStorage.setItem('checkAge', true) // store the token in localstorage
    commit(USER_CHECK_AGE)
  },
  [ACCEPT_COOKIES]: ({ commit, dispatch }) => {
    localStorage.setItem('acceptCookies', true) // store the token in localstorage
    commit(ACCEPT_COOKIES)
  },

}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success'
    Vue.set(state, 'profile', resp.user)
  },
  [USER_ERROR]: (state, resp) => {
    state.status = resp
  },
  [USER_UPDATE_DATA]: (state) => {
    state.status = 'success'
    Vue.set(state.profile, 'support_id', true)
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = {}
  },
  [USER_SET_DEFAULT_SHIP_DATA]: (state, shipData) => {
    Vue.set(state, 'defaultShipData', shipData)
  },
  [USER_CHECK_AGE]: (state) => {
    state.checkAge = true
  },
  [ACCEPT_COOKIES]: (state) => {
    state.acceptCookies = true
  },

}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js